import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { MetricsService } from '../../../../shared/metrics/metrics.service';
import { PageHeaderDropdownItem } from '../../../../shared/page-header/page-header.model';
import { DeregisterComponent } from '../../deregister/deregister.component';
import { ModalService } from '../../../../core/modal/modal.service';
import { TokenComponent } from '../../token/token.component';
import { IKkm } from '../../../../core/modules/retail-places/retail-paces.types';
import { KkmAvailableOperations } from '../../../../core/modules/kkms/kkms.types';
import { ChangeOfdModalComponent } from '../../change-ofd-modal/change-ofd-modal.component';
import { IsnaEnabledService } from '../../shared/services/isna-enabled.service';

@Injectable({
  providedIn: 'root',
})

export class KkmSettingsNavigationService {
  constructor(
    private router: Router,
    private metricsService: MetricsService,
    private modalService: ModalService,
    private location: Location,
    private isnaEnabledService: IsnaEnabledService,
  ) {}

  navigateToSelectSubscriptionPage(kkmId: number): void {
    this.metricsService.ymGoal('Нажата кнопка изменения/выбора подписки');
    this.router.navigate(['/main/kkms/', kkmId, 'tariffs']);
  }

  getDropdownNavigationItems(kkm: IKkm & KkmAvailableOperations): PageHeaderDropdownItem[] {
    return [
      {
        action: () => {
          this.router.navigate([`/main/kkms/re-register-kkm/${kkm.id}`]);
        },
        icon: 'repeat',
        title: 'kkms.kkm.settings.menu.reregistration',
        visibilityCondition: kkm.availableOperations.reRegisterKkm,
      },
      {
        action: () => {
          this.modalService.openOld(DeregisterComponent, {
            kkmId: kkm?.id,
          });
        },
        icon: 'block',
        title: 'kkms.kkm.settings.menu.deregistration',
        visibilityCondition: kkm.availableOperations.deregisterKkm,
      },
      {
        action: () => this.isnaEnabledService.checkIsnaEnabled()
          .subscribe({
            next: () => this.modalService.openOld(ChangeOfdModalComponent, {
              kkmId: kkm?.id,
            }),
          }),
        icon: 'exit',
        title: 'kkms.kkm.settings.menu.change-ofd',
        visibilityCondition: kkm.availableOperations.changeOfd,
      },
    ];
  }

  openTokenModal(kkmId: number): void {
    this.modalService.openOld(TokenComponent, {
      kkmId,
    });
  }

  goToBack(): void {
    this.location.back();
  }
}
